import { IntlShape } from 'react-intl'
import { create, enforce, omitWhen, test } from 'vest'
import {
  ProgressiveDiscount,
  ProgressiveDiscountEffect,
} from '../../../../typings'
import { validationSuite as benefitValidationSuite } from './Editor/Benefit/validation'
import { validationSuite as triggerValidationSuite } from './Editor/Trigger/validation'
import { messages } from './messages'

export function triggerSuite(intl: IntlShape, name: string) {
  const { $t } = intl
  return create(
    (trigger: ProgressiveDiscountEffect[ProgressiveDiscount.Trigger]) => {
      test(name, $t(messages.validation.empty), () => {
        enforce(trigger).isNotUndefined()
      })

      omitWhen(!trigger, () => {
        test(
          `${name}.${ProgressiveDiscount.Trigger}`,
          $t(messages.validation.generic),
          () => {
            enforce(
              triggerValidationSuite(intl)(trigger!).isValidByGroup(
                ProgressiveDiscount.Trigger
              )
            ).isTruthy()
          }
        )
      })
    }
  )
}

export function benefitSuite(intl: IntlShape, name: string) {
  const { $t } = intl
  return create(
    (benefit: ProgressiveDiscountEffect[ProgressiveDiscount.Benefit]) => {
      test(name, $t(messages.validation.empty), () => {
        enforce(benefit).isNotUndefined()
      })

      omitWhen(!benefit, () => {
        test(
          `${name}.${ProgressiveDiscount.Benefit}`,
          $t(messages.validation.generic),
          () => {
            enforce(
              benefitValidationSuite(intl)(benefit!).isValidByGroup(
                ProgressiveDiscount.Benefit
              )
            ).isTruthy()
          }
        )
      })
    }
  )
}
